import React, { useState, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { HOST } from "../../host";
import { GlobalContext } from "../../../App";
import L from "leaflet";
import { bbox, area } from "@turf/turf";
import { logToServer } from "../../logger";
import VectorAttrSplit from "./VectorAttrSplit";
import SpiltVetorLayers from "./SpiltVetorLayers";

function Split() {
    const {
        drawnItems,
        lastRect,
        selectedLayers,
        vis,
        setLBands,
        LayerBands,
        layerControls,
        map,
        userInfo,
        selTab,
        Canvas,
        getCsrfToken
    } = useContext(GlobalContext);

    const [show, setshow] = useState(false);
    const [showSplitByLayer, setshowSplitByLayer] = useState(false);
    const [showSplitByAttribute, setshowSplitByAttribute] = useState(false);
    const [FLayers, setFLayers] = useState([]);
    const [selLayer, SetlLayer] = useState("");
    const [bands, setBands] = useState([]);
    const [Query, setQuery] = useState("");
    const [showwait, setwait] = useState(false);
    const [keyDict, setDict] = useState({});
    const location = useLocation();
    const toolRef = useRef(null);

    

   return (
    <div style={{ position: vis ? "absolute" : "relative" }} className="toolscont">
        
        {/* ── Trigger Button ── */}
        <button
            className="btn text-white"
            title="Split By Layer and Attribute"
            onClick={() => setshow(!show)}
            style={{ backgroundColor: 'black', width: '40px', height: '40px', borderRadius: '50%', border: 'none' }}
        >
            <i className="fa-solid fa-object-ungroup" />
        </button>

        {show && (
            <div ref={toolRef} className="toolsvis" style={{ padding: "10px 12px" }}>

                {/* ── Header ── */}
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingBottom: "8px",
                    marginBottom: "10px",
                    borderBottom: "1px solid rgba(255,255,255,0.12)"
                }}>
                    <span style={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>
                        <i className="fa-solid fa-object-ungroup" style={{ marginRight: "6px", fontSize: "11px" }}></i>
                        Split Tool
                    </span>
                    <span
                        onClick={() => setshow(false)}
                        style={{ color: "#e74c3c", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
                    >
                        &times;
                    </span>
                </div>

                {/* ── Checkboxes ── */}
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "10px" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", margin: 0 }}>
                        <input
                            type="checkbox"
                            checked={showSplitByLayer}
                            onChange={() => setshowSplitByLayer(prev => !prev)}
                        />
                        <span style={{ color: "white", fontSize: "12px" }}>Split By Layer</span>
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", margin: 0 }}>
                        <input
                            type="checkbox"
                            checked={showSplitByAttribute}
                            onChange={() => setshowSplitByAttribute(prev => !prev)}
                        />
                        <span style={{ color: "white", fontSize: "12px" }}>Split By Attribute</span>
                    </label>
                </div>

                {/* ── Sub-tools ── */}
                {showSplitByLayer && <SpiltVetorLayers />}
                {showSplitByAttribute && <VectorAttrSplit />}

                {/* ── Status ── */}
                {showwait && (
                    <p style={{ margin: "8px 0 0", fontSize: "11px", color: "#aaa" }}>
                        <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: "6px" }}></i>
                        Please wait...
                    </p>
                )}

            </div>
        )}
    </div>
);
}

export default Split;
